var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMauritius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 73.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8.1 35.1a4 4 0 0 1 .26-.41l.82-1.1.31-2 3 .06-.72-2-1.08-2.41 5-1.42.12-.34.09-.15h0c.89.18 3.15-.09 3.81-.7l.26-.24 1.03-.77.95-.16.4-.2.32-.35.81-2-1.08-1 1-.9 1.68-1.3.42-.18.45-.11-.88-6.8 1.15.39 1 .25.34-1.88.44-.72-.68-1.59.33-.07.4.09.37.39.26.33h.51l.58-.12.28-.24.31-1.08.24-.28.29-.19.44-.1 1.05-.54 1.28-3 .34-.15.36.07h.61l.95-.18 2.52-.53 2.25 1.72L42.18 3l.2.74 1.23-.2.75-.64.49-.17L45 3l.2.67.26.48.86.63.85 1.22.83 1.47.48 3.29 1 2 .57 1.39.32.43 2 .37.14 2.68 2-.52.33 1.41.17.18 1.41-.21.91 1.1L56 22.68l.39 1.88 3.23 2.5v1.87L62.16 31l.34 3.55-.26.65-.2.5-.32.36-.81.31.91 2.39-1.79 2-.4 1.81h0l-.47 2.88-.47 1.92-1.85 1.91-6.53 1.42.69 1.57-1.67 1.89 2.92 3.56.21 2L51 62.08l-2.16 1.45-.92.62-4.92.75-.24 1.16.35.94-.63.7-3.37.08-.07.65.2.77-4.69.69-.36.22-.54.24h-.46l-.64-.17-.55-.37-.36-.26-2 1.85-1-.19-.82-.36-1.31.9h-.63l-.63-.08-1.32-.7-.41-.07h-.94l-2.51-.48-2-.62-.36-.48h-2.26l-2.91.36-3-.89-.76-1.19-.52-.6-.42-.24-.75-.11-1.23.12-.79.12-.27-1.35-1.12-.26-.24-.37-.8-.57-.31-.46-.83-.8.32-1.37L3.6 58l2.32-1.86L5.81 55l-.18-1.5-.34-1 1-.92.37-1.76-.16-2.69.72-.57.14-.35h-.43l.72.35-.2-.23L3.72 40v-.28l-.24-1.38 2.08-.12 1 .84c.81.35 1-1.59 1-2.34l-.31-.29z",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritius);
export default __webpack_public_path__ + "static/media/mauritius.c606176dded04f5f836534427d487010.svg";
export { ForwardRef as ReactComponent };